var React = require('react');

function Bullet (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6","cy":"6","r":"5","stroke":"#4886FF","fill":"none","fillRule":"evenodd"}));
}

Bullet.defaultProps = {"width":"12","height":"12"};

module.exports = Bullet;

Bullet.default = Bullet;



//////////////////
// WEBPACK FOOTER
// ./src/icons/bullet.svg
// module id = 643
// module chunks = 0